import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { withFeatureFlags } from '@atlassian/mpac-feature-flags';
import { SearchOverlay } from '@atlassian/mpac-search';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getFilters } from '../../../../common/config/filters';
import CommonPropTypes from '../../../../common/constants/proptypes/CommonPropTypes';
import AddonDiscoveryPropTypes from '../../../constants/proptypes/AddonDiscoveryPropTypes';

// eslint-disable-next-line max-lines-per-function
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TextSearchWrapper = props => {
  const [showSearchOverlay, setShowSearchOverlay] = useState(false);
  const [query, setQuery] = useState(props.filters.get(getFilters().getIn(['query', 'key'])) || '');
  const formQuery = props.filters.get(getFilters().getIn(['query', 'key'])) || '';
  useEffect(() => {
    const currentQuery = props.filters.get(getFilters().getIn(['query', 'key'])) || '';
    setQuery(currentQuery || '');
  }, [formQuery]);
  const onChangeQuery = () => null;
  const onSubmit = e => {
    e.preventDefault();
  };
  const onClick = () => {
    setShowSearchOverlay(true);
  };
  const SearchComponent = props.searchComponent;
  const searchOverlaySource = window.location.pathname.includes('/search') ? 'search-page' : 'home-page-hero';
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "text-search-wrapper",
    children: [/*#__PURE__*/_jsx("form", {
      onSubmit: onSubmit,
      children: /*#__PURE__*/_jsx(SearchComponent, _objectSpread(_objectSpread({}, props.extraProps), {}, {
        perspective: props.perspective,
        onChangeQuery: onChangeQuery,
        onClick: onClick,
        query: query
      }))
    }), showSearchOverlay && /*#__PURE__*/_jsx(SearchOverlay, {
      onClose: () => setShowSearchOverlay(false),
      analytics: {
        source: searchOverlaySource
      }
    })]
  });
};
TextSearchWrapper.propTypes = {
  fireAnalyticsEvent: PropTypes.func.isRequired,
  extraProps: PropTypes.object,
  filters: CommonPropTypes.filters.isRequired,
  onChange: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  /**
   * searchComponent must contain an input or button element with type "submit"
   * so that the onSubmit of this component's form can be executed
   */
  searchComponent: PropTypes.func.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
};
TextSearchWrapper.defaultProps = {
  extraProps: {}
};
export default withFeatureFlags(TextSearchWrapper);